/**
 * @generated SignedSource<<3477899647f215e66b809c4dbdcc1ed6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionDeleteInput = {
  id: string;
};
export type PromotionActionsMutationButtonStack_promotionDeleteMutation$variables = {
  input: PromotionDeleteInput;
};
export type PromotionActionsMutationButtonStack_promotionDeleteMutation$data = {
  readonly promotionDelete: {
    readonly id: string;
  };
};
export type PromotionActionsMutationButtonStack_promotionDeleteMutation = {
  response: PromotionActionsMutationButtonStack_promotionDeleteMutation$data;
  variables: PromotionActionsMutationButtonStack_promotionDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionActionsMutationButtonStack_promotionDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Promotion",
        "kind": "LinkedField",
        "name": "promotionDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionActionsMutationButtonStack_promotionDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Promotion",
        "kind": "LinkedField",
        "name": "promotionDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a7e7e51dad8e6fa373c45fa4f8f8dc1e",
    "id": null,
    "metadata": {},
    "name": "PromotionActionsMutationButtonStack_promotionDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionActionsMutationButtonStack_promotionDeleteMutation(\n  $input: PromotionDeleteInput!\n) {\n  promotionDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9b6b531c80b97d1028c715551cea069";

export default node;
